module.exports = __webpack_public_path__ + "static/media/electric-hybridVehicles.2264ef5c.svg";